import { isWindows } from 'react-device-detect';
const scrollTimeouts = new WeakMap();
function onScroll(e) {
    const target = e.target === document ? document.documentElement : e.target;
    if (!(target instanceof Element)) return;
    target.classList.add('is-scrolling');
    const existing = scrollTimeouts.get(target);
    if (existing) clearTimeout(existing);
    const id = setTimeout(()=>{
        target.classList.remove('is-scrolling');
        scrollTimeouts.delete(target);
    }, 1000);
    scrollTimeouts.set(target, id);
}
const SCROLLBAR_STYLE_ID = 'windows-scrollbar-visibility';
const SCROLLBAR_CSS = `
/* Chrome, Safari — webkit custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

*:hover::-webkit-scrollbar-thumb,
*.is-scrolling::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}

*:hover::-webkit-scrollbar-thumb:hover,
*.is-scrolling::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.35);
}

@supports not selector(::-webkit-scrollbar) {
  * {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
  }

  *:hover,
  *.is-scrolling {
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  }
}
`;
function injectScrollbarStyles() {
    if (typeof document === 'undefined') {
        return;
    }
    if (document.getElementById(SCROLLBAR_STYLE_ID)) {
        return;
    }
    const style = document.createElement('style');
    style.id = SCROLLBAR_STYLE_ID;
    style.textContent = SCROLLBAR_CSS;
    document.head.appendChild(style);
}
export function installScrollbarVisibility() {
    if (!isWindows) {
        return;
    }
    injectScrollbarStyles();
    document.addEventListener('scroll', onScroll, {
        passive: true,
        capture: true
    });
}
